import { render } from "./CustomRedirectControl.vue?vue&type=template&id=39cd484c&ts=true"
import script from "./CustomRedirectControl.vue?vue&type=script&lang=ts"
export * from "./CustomRedirectControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/workflow/infrastructure/component/rete/customization/CustomRedirectControl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39cd484c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39cd484c', __exports__)) {
    api.reload('39cd484c', __exports__)
  }
  
  module.hot.accept("./CustomRedirectControl.vue?vue&type=template&id=39cd484c&ts=true", () => {
    api.rerender('39cd484c', render)
  })

}


export default __exports__